import { Component, HostListener } from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {NgForOf, NgIf} from "@angular/common";
import {NgSelectModule} from "@ng-select/ng-select";
import {KeycloakService} from "keycloak-angular";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-modal-cerrar-sesion',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    NgSelectModule,
  ],
  templateUrl: './modal-cerrar-sesion.component.html',
  styleUrl: './modal-cerrar-sesion.component.scss'
})
export class ModalCerrarSesionComponent {

  constructor(private modalRef: BsModalRef, private keycloakService: KeycloakService) {

  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close();
  }

  close() {
    this.modalRef.hide();
  }

  cerrarSesion() {
    this.keycloakService.logout(environment.keyCloakRedirectUri);
  }




}
